import React from 'react';
import { Button } from 'react-bootstrap';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  loading = false,
}) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <div className='d-flex justify-content-center align-items-center gap-2 mt-4'>
      <Button
        variant='light'
        size='sm'
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || loading}
        className='border d-flex align-items-center'
        style={{
          minWidth: '36px',
          height: '36px',
          borderRadius: '8px',
        }}
      >
        <ChevronLeft size={16} />
      </Button>

      {getPageNumbers().map((page, index) => (
        <React.Fragment key={index}>
          {page === '...' ? (
            <span className='px-2 text-muted'>...</span>
          ) : (
            <Button
              variant={currentPage === page ? 'primary' : 'light'}
              size='sm'
              onClick={() => onPageChange(page)}
              disabled={loading}
              className='border'
              style={{
                minWidth: '36px',
                height: '36px',
                borderRadius: '8px',
                background:
                  currentPage === page
                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    : 'white',
                color: currentPage === page ? 'white' : '#333',
                border: currentPage === page ? 'none' : '1px solid #e2e8f0',
                fontWeight: currentPage === page ? 'bold' : 'normal',
              }}
            >
              {page}
            </Button>
          )}
        </React.Fragment>
      ))}

      <Button
        variant='light'
        size='sm'
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages || loading}
        className='border d-flex align-items-center'
        style={{
          minWidth: '36px',
          height: '36px',
          borderRadius: '8px',
        }}
      >
        <ChevronRight size={16} />
      </Button>
    </div>
  );
};

export default Pagination;
